import template from './support.html'
import controller from './support.controller'
import service from './support.service'
import './support.scss'

let module = angular.module('support', [
	'ionic'
])
.service('Support', service)
.config(($stateProvider) => {
	"ngInject";

	$stateProvider
		.state('tab.support', {
			url: '/support?upload&product',
			views: {
				'tab-more': {
					template: template,
					controller: controller,
					controllerAs: 'support'
				}
			},
		})
})
.service('', service)
.run(function($state, $ionicPopup, $filter) {
	document.addEventListener("screenshot", function() {
		$ionicPopup.show({
			title: $filter('ucfirst')($filter('translate')('screenshot_upload_title')),
			subTitle: $filter('ucfirst')($filter('translate')('screenshot_upload_subtitle')),
			buttons: [
				{
					text: $filter('ucfirst')($filter('translate')('no')),
				},
				{
					text: $filter('ucfirst')($filter('translate')('yes')),
					type: 'button-assertive',
					onTap: function(e) {
						$state.go('tab.support', { upload: 1 });
					}
				}
			]
		});
	}, false);
})
.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/support/support.js